
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { setTheme } from 'ngx-bootstrap/utils';
import { MainComponent } from './modules/layout/components/main/main.component';
import { AccessComponent } from './pages/access-module/access.component';
import { OperationSharerService } from './service/operation-sharer.service';

@Component({
    selector: 'body',
    imports: [RouterOutlet, RouterLink, RouterLinkActive, AccessComponent, MainComponent],
    providers: [OperationSharerService],
    templateUrl: './app.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor() {

    setTheme('bs4');
  }
  title = 'Portal Autos (Angular 17)';
}
